import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=28f2b5aa&"
import script from "./Students.vue?vue&type=script&lang=ts&"
export * from "./Students.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports